import { Component, DOCUMENT, Inject, OnInit } from '@angular/core';
import { environment } from '@environment';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'sb-unauthorized-faq-error-page',
    templateUrl: './unauthorized-faq-error-page.component.html',
    styleUrls: ['./unauthorized-faq-error-page.component.scss'],
    standalone: true,
})
export class UnauthorizedFaqErrorPageComponent implements OnInit {
    constructor(
        private titleService: Title,
        private router: Router,
        private translateService: TranslateService,
        @Inject(DOCUMENT) private document: Document,
    ) {}

    ngOnInit() {
        this.setTitle(this.translateService.instant('Access restricted'));

        // need to reset min-width: 1000px
        this.document.body.style.minWidth = 'unset';

        const subscription = this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe(() => {
            this.setTitle('Socialboards');
            subscription.unsubscribe();
        });
    }

    login() {
        const redirectUrl = encodeURIComponent(window.location.href);
        window.location.href = environment.loginAppUrl + '?url=' + redirectUrl;
    }

    private setTitle(newTitle: string) {
        this.titleService.setTitle(newTitle);
    }
}
